import {Position} from "../components/transform/position";
import {BaseLevel} from "../components/physics/baseLevel";
import {AppState} from "../app";
import {Acceleration} from "../components/physics/acceleration";
import {Velocity} from "../components/physics/velocity";
import {Gravity} from "../components/physics/gravity";
import {Rotation} from "../components/transform/rotation";
import {RotationMotor} from "../components/inputObject/rotationMotor";


export function updatePhysics({entities, time, soundEvents}: AppState) {

    entities.forEach([Acceleration, Gravity], (e) => {

        e.Acceleration.value.addTo(e.Gravity.value)
    })

    entities.forEach([Position, Velocity, Acceleration], (e) => {

        e.Velocity.value.addTo(e.Acceleration.value.multiply(time.deltaTime))
        e.Position.value.addTo(e.Velocity.value.multiply(time.deltaTime))

        e.Acceleration.value.set(0, 0)
    })

    entities.forEach([BaseLevel, Position, Velocity], (e) => {

        e.BaseLevel.isColliding = e.Position.value.y < e.BaseLevel.baseLevel && e.Velocity.value.y < 0
        if (e.BaseLevel.isColliding) {

            const speedAbs = Math.abs(e.Velocity.value.y)
            e.BaseLevel.isColliding = true;
            e.BaseLevel.collisionVelocity = speedAbs;

            const bounce = 0.0
            e.Position.value.y = e.BaseLevel.baseLevel;
            e.Velocity.value.y = -e.Velocity.value.y * bounce

        }
    })

    entities.forEach([ Rotation, RotationMotor], (e) => {

        if(e.RotationMotor.active)
            e.Rotation.value += time.deltaTime * e.RotationMotor.speed
    })
}